// extracted by mini-css-extract-plugin
export var borderRadius = "_af-4";
export var large = "_af-3";
export var logoContainer = "_af-0";
export var nameLogo = "_af-2";
export var small = "_af-1";